module.exports = __webpack_public_path__ + "617c9af18c932da87a64cc1b3d65e0fa.svg";